import { model } from "model";
import { ManageAreas } from './ManageAreas'
import { Spinner } from "reactstrap";

export const ManageAreasPage = () => {
    const { activeAuditLoaded } = model.useAuditCtx();
    return activeAuditLoaded ? <ManageAreas /> : <Spinner />;
}